import { connect } from "react-redux";
import { DialysisConcentrationToggle as Component } from "./DialysisConcentrationToggle";
import { setConcentration } from "./store/actions";

function mapStateToProps(state) {
  return {
    concentration: state.dialysisConcentration.concentration,
    concentrationSelected: state.dialysisConcentration.concentrationSelected,
  };
}

export const DialysisConcentrationToggle = connect(mapStateToProps, {
  setConcentration,
})(Component);
